import React, { useState, useEffect } from 'react';
import Spin from '../../../components/loading';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import useSetState from '../../../hooks/useSetState';
import PackagesReportTab from './tabs/packagesReportTab';
import ChargingRseeReportTab from './tabs/chargingRseeReportTab';
import PurchasePackagesReportTab from './tabs/PurchasePackagesReportTab';

const PackagesReportIndex = props => {
  const [controls, setControls] = useSetState({
    activeTab: '1',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const toggle = tab => {
    if (controls.activeTab !== tab) {
      onChangeValue('activeTab', tab);
    }
  };

  return (
    <Spin>
      <section className='page-header'>
        <h1>{locales('packages.report')}</h1>
      </section>

      <article>
        <main>
          <div className='col-12 py-3 bg-white'>
            <Nav className='p-0' tabs>
              <NavItem className='d-flex'>
                <NavLink
                  className={`${
                    controls.activeTab === '1' ? 'bg-primary text-white' : ''
                  } 
                  ${classnames({
                    active: controls.activeTab === '1',
                  })}`}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                  {locales('packages')}
                </NavLink>
                <NavLink
                  className={`${
                    controls.activeTab === '2' ? 'bg-primary text-white' : ''
                  } 
                  ${classnames({
                    active: controls.activeTab === '2',
                  })}`}
                  onClick={() => {
                    toggle('2');
                  }}
                >
                  {locales('rsee.charging.report')}
                </NavLink>
                <NavLink
                  className={`${
                    controls.activeTab === '3' ? 'bg-primary text-white' : ''
                  } 
                  ${classnames({
                    active: controls.activeTab === '3',
                  })}`}
                  onClick={() => {
                    toggle('3');
                  }}
                >
                  {locales('buy.package.report')}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent className='p-2 bg-light' activeTab={controls.activeTab}>
              <TabPane tabId='1'>
                <PackagesReportTab />
              </TabPane>
              <TabPane tabId='2'>
                <ChargingRseeReportTab />
              </TabPane>
              <TabPane tabId='3'>
                <PurchasePackagesReportTab />
              </TabPane>
            </TabContent>
          </div>
        </main>
      </article>
    </Spin>
  );
};

export default PackagesReportIndex;
